import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';

const TabSection = styled.div`
  border-bottom: 1px solid #e5e5ea;
  display: flex;
`;
const Tab = styled.div<{ isSelected?: boolean}>`
  background-color: ${props => (props.isSelected ? '#444' : '#f7f7f9')};
  color: ${props => (props.isSelected ? '#fff' : '#444')};
  border-radius: 5px;
  padding: 14px 45px;
  cursor: pointer;
  transition: all .2s ease;
`;
interface Props {
    indexSelected?: number;
    setIndexSelected?: any;
}
const tabArray = [
  { value: 0, name: 'General' },
  { value: 1, name: 'Tax Search' },
];

const CompanySettingsTabs = (props: Props) => {
  return (
    <TabSection>
      <div style={{ margin: 24, display: 'flex' }}>
        {tabArray.map((ta, i) => {
          return (
            <Tab
              isSelected={i === props.indexSelected}
              onClick={() => {
                props.setIndexSelected(i);
              }}
            >
              {ta.name}
            </Tab>
          );
        })}
      </div>
    </TabSection>
  );
};

export default CompanySettingsTabs;
